"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBanner = exports.GKBottomPane = exports.GKRightPane = exports.GKLeftPane = exports.GKContent = exports.GKFooter = exports.GKHeader = exports.GKLayoutContainer = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../components");
var common_1 = require("../../common");
require("./LayoutContainer.css");
var GKLayoutContainer = function (props) {
    var uniqueId = (0, common_1.usePersistentId2)(props.id);
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-layout-container",
        id: uniqueId,
    }), children = _a.children, alertsContext = _a.alertsContext, alertsOverlay = _a.alertsOverlay, customAlertsPlacement = _a.customAlertsPlacement, others = __rest(_a, ["children", "alertsContext", "alertsOverlay", "customAlertsPlacement"]);
    var content = (React.createElement(common_1.WindowSizeManager, null,
        React.createElement("div", __assign({}, others),
            alertsContext && !customAlertsPlacement && (React.createElement(components_1.GKContextualAlerts, { className: alertsOverlay ? "alerts-overlay" : "alerts-inline", global: alertsContext === "global", "data-qa": props["data-qa"] + "--contextual-alerts" })),
            children)));
    return alertsContext ? (React.createElement(components_1.GKAlertsManager, { baseId: uniqueId, global: alertsContext === "global" }, content)) : (content);
};
exports.GKLayoutContainer = GKLayoutContainer;
var LayoutContent = function (props) {
    var _a = (0, common_1.useMergedProps)(props, { _gkComponentIdentifier: props.name }), children = _a.children, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, Tag = _a.Tag, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    name = _a.name, mergedProps = __rest(_a, ["children", "xs", "sm", "md", "lg", "xl", "Tag", "name"]);
    var responsiveResult = (0, common_1.useResponsive2)({ xs: xs, sm: sm, md: md, lg: lg, xl: xl });
    return responsiveResult || children ? (React.createElement(Tag, __assign({}, mergedProps),
        responsiveResult,
        children)) : null;
};
var GKHeader = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "header", name: "gk-header" }, props))); };
exports.GKHeader = GKHeader;
var GKFooter = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "footer", name: "gk-footer" }, props))); };
exports.GKFooter = GKFooter;
var GKContent = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "div", name: "gk-content" }, props))); };
exports.GKContent = GKContent;
var GKLeftPane = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "div", name: "gk-left-pane" }, props))); };
exports.GKLeftPane = GKLeftPane;
var GKRightPane = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "div", name: "gk-right-pane" }, props))); };
exports.GKRightPane = GKRightPane;
var GKBottomPane = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "div", name: "gk-bottom-pane" }, props))); };
exports.GKBottomPane = GKBottomPane;
var GKBanner = function (props) { return (React.createElement(LayoutContent, __assign({ Tag: "div", name: "gk-banner" }, props))); };
exports.GKBanner = GKBanner;
exports.default = exports.GKLayoutContainer;
